export default __webpack_public_path__ + "static/media/newpreviouspaper.98f5a76e.png";